import Http from '../Http'

export default {
	async all () {
		try {
			const response = await Http.get('api/subscriber/languages') 
			return response.data
		} catch (err) {
			throw err
		}
	},
}
